var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.active),expression:"active"}]},[_c('hr'),_c('b-spinner',{attrs:{"small":"","type":"grow","variant":"warning"}}),_c('span',{staticClass:"small-gray"},[_vm._v(_vm._s(_vm.message ? _vm.message : _vm.$t('general.loadingEllipsis', 'loading...')))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }